import validate from "/home/runner/work/genoch-mercato-client-dashboard/genoch-mercato-client-dashboard/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/work/genoch-mercato-client-dashboard/genoch-mercato-client-dashboard/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}